/* GASSISA
=========================================================================================
* Descripcion: Menu de acciones portable para Centro de Costos
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion menu portatil
*      2       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Contenedor visual para recuperar colores e iconos
*      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Restauracion de estructura actions del layout normal
* ---------------------------------------------------------------------------------------
========================================================================================= */

import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import UndoIcon from '@mui/icons-material/Undo';
import UpdateIcon from '@mui/icons-material/Update';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDoubleClickPrevention } from "../../../hooks/useDoubleClickPrevention";

export default function MnuCentroCostosActionsPortatil({
    onRegresar,
    onDeshacerCambios,
    onActualizarCostos,
    onOpenModalOferta,
    hayCambios,
    loading,
    listaArticulos = [],
    hayArticulosConOferta
}) {
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={onRegresar}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            {hayCambios && onDeshacerCambios && (
                <Tooltip title={"Deshacer cambios"}>
                    <IconButton onClick={() => executeWithProtection(onDeshacerCambios)} color="warning" disabled={isProcessing}>
                        <UndoIcon className="icon" /><p className="icon">Deshacer</p>
                    </IconButton>
                </Tooltip>
            )}
            {onActualizarCostos && (
                <Tooltip title={loading ? "Aplicando cambios..." : listaArticulos.length === 0 ? "Primero busca artículos" : "Aplicar costos a artículos visibles"}>
                    <span>
                        <IconButton onClick={() => executeWithProtection(onActualizarCostos)} disabled={isProcessing || loading || listaArticulos.length === 0}>
                            <UpdateIcon className="icon" /><p className="icon">Aplicar</p>
                        </IconButton>
                    </span>
                </Tooltip>
            )}
            {onOpenModalOferta && (
                <Tooltip title={loading ? "Procesando..." : hayArticulosConOferta ? "Eliminar ofertas de artículos visibles" : "Aplicar oferta a artículos visibles"}>
                    <span>
                        <IconButton
                            onClick={() => executeWithProtection(onOpenModalOferta)}
                            disabled={isProcessing || loading || listaArticulos.length === 0}
                            color={hayArticulosConOferta ? "error" : "primary"}
                        >
                            {hayArticulosConOferta ? (
                                <DeleteIcon className="icon" />
                            ) : (
                                <LocalOfferIcon className="icon" />
                            )}
                            <p className="icon">{hayArticulosConOferta ? "Eliminar Oferta" : "Aplicar Oferta"}</p>
                        </IconButton>
                    </span>
                </Tooltip>
            )}
        </Fragment>
    );
}
